import { HTMLAttributes } from 'react'

import Button from '@/components/base/button'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media from '@/components/base/media'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'
import { isAcademy, isCorporate } from '@/constants'

import { productIconListRevealAnimation } from './animations'
import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type ProductIconListProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: {
      image: WPImage
      paragraph: string
    }[]
  }>

const ProductIconList = ({ items, ...props }: ProductIconListProps) => {
  return (
    <Motion animation={productIconListRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-[1.6rem]">
              {items?.map(({ image, paragraph }, index) => (
                <div
                  className={cn([
                    'col-span-2',
                    'md:col-span-3',
                    'lg:col-span-6'
                  ])}
                  key={index}
                >
                  <Button
                    isLiquid
                    variant="secondary"
                    full={true}
                    isActive
                    className={cn([
                      'min-h-[4.8rem] flex-col items-start gap-x-spacing-sm gap-y-spacing-sm !p-spacing-sm lg:flex-row lg:items-center lg:p-spacing-sm [&_svg[data-background]]:stroke-border-menu-light',
                      {
                        '[&_span[data-background]]:border-transparent':
                          isAcademy
                      }
                    ])}
                    data-motion-button
                  >
                    {isCorporate ? (
                      <Media image={image} className="size-spacing-xl" />
                    ) : null}
                    <hr className="hidden h-[4rem] border-l border-dashed border-surface-primary-light opacity-30 lg:block" />
                    <Typography variant="regular" className="text-left">
                      {paragraph}
                    </Typography>
                  </Button>
                </div>
              ))}
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default ProductIconList
